/* Vijvercentrum Plus: landingspagina (sections/plus-landing.liquid, 02-10-2026).
   1. Rekenhulp: bestellingen per jaar tussen de drempels maal de verzendkosten, min het lidmaatschap.
      De bedragen komen uit data-vpl-vk en data-vpl-prijs (centen), dus uit de instellingen en het product.
   2. Balk onderaan op mobiel: zichtbaar zodra de hoofdknop uit beeld is, weg bij het slot.
   3. Meting: alleen na toestemming (Shopify Customer Privacy), een gebeurtenis vp_plus_lid_klik met de
      plek van de knop. Geen persoonsgegevens. */
(function () {
  var root = document.querySelector('[data-vpl]');
  if (!root) return;

  function euro(cents) {
    var negatief = cents < 0;
    var abs = Math.abs(Math.round(cents));
    var tekst = Math.floor(abs / 100) + ',' + String(abs % 100).padStart(2, '0');
    return (negatief ? '− € ' : '€ ') + tekst;
  }

  // 1. Rekenhulp
  var vk = parseInt(root.getAttribute('data-vpl-vk'), 10);
  var prijs = parseInt(root.getAttribute('data-vpl-prijs'), 10);
  var schuif = root.querySelector('[data-vpl-aantal]');
  if (schuif && vk > 0 && prijs > 0) {
    var aantalTekst = root.querySelector('[data-vpl-aantal-tekst]');
    var bespaard = root.querySelector('[data-vpl-bespaard]');
    var netto = root.querySelector('[data-vpl-netto]');
    var nettoLabel = root.querySelector('[data-vpl-netto-label]');
    var reken = function () {
      var n = parseInt(schuif.value, 10) || 0;
      var winst = n * vk - prijs;
      if (aantalTekst) aantalTekst.textContent = String(n);
      if (bespaard) bespaard.textContent = euro(n * vk);
      if (netto) {
        netto.textContent = euro(winst);
        netto.classList.toggle('vpl-negatief', winst < 0);
      }
      if (nettoLabel) nettoLabel.textContent = winst < 0 ? 'Nog terug te verdienen' : 'Jouw voordeel';
      schuif.setAttribute('aria-valuetext', n + (n === 1 ? ' bestelling' : ' bestellingen'));
    };
    schuif.addEventListener('input', reken);
    reken();
  }

  // 2. Balk onderaan (alleen als hij er is: niet voor leden)
  var balk = root.querySelector('[data-vpl-balk]');
  var hoofdknop = root.querySelector('[data-vpl-hoofdknop]');
  var slot = root.querySelector('.vpl-slot');
  if (balk && hoofdknop && 'IntersectionObserver' in window) {
    balk.hidden = false;
    var hoofdZichtbaar = true;
    var slotZichtbaar = false;
    var werkBij = function () {
      balk.classList.toggle('is-zichtbaar', !hoofdZichtbaar && !slotZichtbaar);
    };
    new IntersectionObserver(function (items) {
      hoofdZichtbaar = items[0].isIntersecting;
      werkBij();
    }).observe(hoofdknop);
    if (slot) {
      new IntersectionObserver(function (items) {
        slotZichtbaar = items[0].isIntersecting;
        werkBij();
      }).observe(slot);
    }
  }

  // 3. Meting na toestemming
  root.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-vpl-ingang]') : null;
    if (!link) return;
    try {
      // Zelfde regel als assets/mijn-vijver-link.js: nooit bij Global Privacy Control of in de editor.
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var mag =
        !(window.navigator && window.navigator.globalPrivacyControl === true) &&
        !(window.Shopify && window.Shopify.designMode) &&
        !!privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true;
      if (mag && typeof window.gtag === 'function') {
        window.gtag('event', 'vp_plus_lid_klik', { ingang: link.getAttribute('data-vpl-ingang') });
      }
    } catch (fout) {
      /* meten mag nooit de klik tegenhouden */
    }
  });
})();
